import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, CalendarCheck, MessageSquare } from "lucide-react";
import { COMPANY } from "../mock";

// Sticky mobile call-to-action bar (Dead Bug Edwards style) - mobile only.
export default function MobileCTABar() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 260);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-[850] transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      role="region"
      aria-label="Quick contact actions"
    >
      <div className="bg-brand-navy/95 backdrop-blur-md border-t border-white/10 shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.6)] px-3 pt-2.5 pb-[calc(env(safe-area-inset-bottom,0px)+10px)]">
        <div className="grid grid-cols-3 gap-2.5">
          <a
            href={COMPANY.phoneHref}
            data-call-source="mobile-bar"
            data-testid="mobile-cta-call"
            className="flex flex-col items-center justify-center gap-1 h-14 rounded-xl bg-white/10 text-white font-heading font-bold text-xs ring-1 ring-white/15 active:scale-95 transition-transform"
          >
            <Phone className="h-5 w-5 text-brand-sky2" />
            Call
          </a>
          <a
            href={COMPANY.smsHref}
            data-call-source="mobile-bar"
            data-testid="mobile-cta-text"
            className="flex flex-col items-center justify-center gap-1 h-14 rounded-xl bg-white/10 text-white font-heading font-bold text-xs ring-1 ring-white/15 active:scale-95 transition-transform"
          >
            <MessageSquare className="h-5 w-5 text-brand-sky2" />
            Text
          </a>
          <button
            onClick={() => navigate("/estimate")}
            className="flex flex-col items-center justify-center gap-1 h-14 rounded-xl bg-brand-gold text-brand-navy font-heading font-extrabold text-xs shadow-gold active:scale-95 transition-transform"
          >
            <CalendarCheck className="h-5 w-5" />
            Free Quote
          </button>
        </div>
      </div>
    </div>
  );
}
